<template>
    <div class="add-model">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="platforms" title="Agregar plataformas de transmicion">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <label for="">Selecciona la plataforma</label>
                <div>
                    <div @click="selectPlatform(index)" v-for="(cam, index) in cams" :key="index" :ref="'platform' + index" class="img-container">
                        <img :src="cam.img" alt="">
                    </div>
                </div>
                <label for="">Ingresa el nombre de usuario de la plataforma</label>
                <div class="form">
                    <input type="text" v-model="$v.modelUserPlatformValue.$model">
                </div>
                <label for="" v-if="this.platformIndex === 2">Ingresa la contraseña del usuario</label>
                <div>
                    <input type="password" v-model="$v.modelUserPlatformPasswordValue.$model" v-if="this.platformIndex === 2">
                </div>
                <div>
                    <button class="platform-button" @click="addUserPlatfom">Agregar plataforma</button>
                </div>
                <label for="" v-if="addedPlatform.length > 0">Agregados: </label>
                <div v-for="(platform, index) in addedPlatform" :key="index">
                    <img :src="platform.img" alt="">
                    <label for="">{{platform.name}}</label>
                    <div @click="deletePlatform(index)"><i class="fa-solid fa-trash fa-lg"></i></div>
                </div>
                <button @click="closePlatformDetails()">Guardar</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="bankdetails" title="Agregar información bancaria">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <label for="">Nombres y apellidos del titular de la cuenta</label>
                <input type="text" v-model="$v.nombreTitularValue.$model" placeholder="Agregar nombre">
                <div v-if="$v.nombreTitularValue.$error" class="error">El nombre es un campo obligatorio</div>
                <label for="">Tipo de documento del titular de la cuenta</label>
                <select name="" id="" v-model="$v.typeDocumentTitularValue.$model">
                    <option value="cc">Cedula de ciudadania</option>
                    <option value="ce">Cedula de extranjeria</option>
                    <option value="pasaport">Pasaporte</option>
                    <option value="other">Otro</option>
                </select>
                <div v-if="$v.typeDocumentTitularValue.$error" class="error">El tipo de documento es un campo obligatorio</div>
                <label for="">Banco</label>
                <input type="text" v-model="$v.bankValue.$model" placeholder="Agregar banco">
                <div v-if="$v.typeDocumentTitularValue.$error" class="error">El banco es un campo obligatorio</div>
                <label for="">Tipo de cuenta</label>
                <select name="" id="" v-model="$v.bankTypeValue.$model">
                    <option value="ahorros">Ahorros</option>
                    <option value="corriente">Corriente</option>
                </select>
                <div v-if="$v.bankTypeValue.$error" class="error">El banco es un campo obligatorio</div>
                <label for="">N° Documento del titular de la cuenta</label>
                <input type="number" v-model="$v.documentTitularValue.$model" placeholder="Agregar documento">
                <div v-if="$v.documentTitularValue.$error" class="error">El numero de documento es un campo obligatorio</div>
                <label for="">N° de cuenta del titular</label>
                <input type="number" v-model="$v.CuentaTitularValue.$model" placeholder="Agregar documento">
                <div v-if="$v.CuentaTitularValue.$error" class="error">El numero de cuenta es un campo obligatorio</div>
                <button @click="closeBackDetails()">Guardar</button>
            </div>
        </b-modal>
        <center><h3>AGREGAR MODELO</h3></center>
        <div class="info">
            <div class="column">
                <center>
                    <label for="">Nombre</label>
                    <input type="text" v-model="$v.nameValue.$model" placeholder="Agregar nombre">
                    <div v-if="$v.nameValue.$error" class="error">El nombre es un campo obligatorio</div>
                    <label for="">Apellido</label>
                    <input type="text" v-model="$v.lastNameValue.$model" placeholder="Agregar apellido">
                    <div v-if="$v.lastNameValue.$error" class="error">El apellido es un campo obligatorio</div>
                    <label for="">Tipo de documento</label>
                    <select name="" id="" v-model="$v.typeDocumentValue.$model">
                        <option value="cc">Cedula de ciudadania</option>
                        <option value="ce">Cedula de extranjeria</option>
                        <option value="pasaport">Pasaporte</option>
                        <option value="other">Otro</option>
                    </select>
                    <div v-if="$v.typeDocumentValue.$error" class="error">El tipo de documento es un campo obligatorio</div>
                    <label for="">Documento</label>
                    <input type="number" v-model="$v.documentValue.$model" placeholder="Agregar documento">
                    <div v-if="$v.documentValue.$error" class="error">El Documento es un campo obligatorio</div>
                    <label for="">Fecha de nacimiento</label>
                    <input type="date" v-model="$v.dayOfBirdthValue.$model">
                    <div v-if="$v.dayOfBirdthValue.$error" class="error">la fecha de nacimiento es un campo obligatorio</div>
                    <label for="">Nacionalidad</label>
                    <select name="" id="" v-model="$v.countryValue.$model">
                        <option v-for="(elem, index) in countries" :key="index" :value="elem">{{ elem }}</option>
                    </select>
                    <div v-if="$v.countryValue.$error" class="error">La Nacionalidad es un campo obligatorio</div>
                </center>
            </div>
            <div class="column">
                <center>
                    <label for="">Turno</label>
                    <select name="" id="" v-model="$v.turnoValue.$model">
                        <option value="mañana">Mañana</option>
                        <option value="tarde">Tarde</option>
                        <option value="noche">Noche</option>
                    </select>
                    <label for="">Sede</label>
                    <select name="" id="" v-model="$v.sedeValue.$model">
                        <option :value="sede" v-for="(sede, index) in sedes" :key="index">{{sede}}</option>
                    </select>
                    <div v-if="$v.turnoValue.$error" class="error">El turno es un campo obligatorio</div>
                    <label for="">Celular</label>
                    <vue-tel-input v-model.lazy="$v.phoneValue.$model" onpaste="return false;"
                        @keypress.native="checkPhoneNumber" :preferredCountries="['co']" v-bind:placeholder="'phone'">
                    </vue-tel-input>
                    <div v-if="$v.phoneValue.$error" class="error">El celular es un campo obligatorio</div>
                    <label for="">Correo electronico</label>
                    <input type="email" v-model="$v.emailValue.$model" placeholder="Agregar correo">
                    <div>
                        <button @click="addbackDetails()">Añadir datos bancarios</button>
                        <button @click="addPlataform()">Añadir plataformas</button>
                    </div>
                    <button class="register-button" @click="saveData()">Registrar</button>
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import {required, email, numeric} from 'vuelidate/lib/validators'
import API from '@/api'

export default {
    name: 'AgregarModelo',
    methods: {
        saveData() {
            if (this.$v.nameValue.$model === null) {
                this.$v.nameValue.$touch()
                return
            }
            if (this.$v.lastNameValue.$model === null) {
                this.$v.lastNameValue.$touch()
                return
            }
            if (this.$v.typeDocumentValue.$model === null) {
                this.$v.typeDocumentValue.$touch()
                return
            }
            if (this.$v.documentValue.$model === null) {
                this.$v.documentValue.$touch()
                return
            }
            if (this.$v.dayOfBirdthValue.$model === null) {
                this.$v.dayOfBirdthValue.$touch()
                return
            }
            if (this.$v.countryValue.$model === null) {
                this.$v.countryValue.$touch()
                return
            }
            if (this.$v.turnoValue.$model === null) {
                this.$v.turnoValue.$touch()
                return
            }
            if (this.$v.phoneValue.$model === null) {
                this.$v.phoneValue.$touch()
                return
            }
            if (this.$v.sedeValue.$model === null) {
                this.$v.sedeValue.$touch()
                return
            }
            if (this.validateBankInfo() === false) {
                return
            }
            var info = {
                phone: this.$v.phoneValue.$model,
                stagename: this.$v.nameValue.$model,
                lastname: this.$v.lastNameValue.$model,
                document_type: this.$v.typeDocumentValue.$model,
                document: this.$v.documentValue.$model,
                country: this.$v.countryValue.$model,
                date_of_birth: this.$v.dayOfBirdthValue.$model,
                turno: this.$v.turnoValue.$model,
                sede: this.$v.sedeValue.$model,
                email: this.$v.emailValue.$model
            }
            API.ModelRegister(info)
                .then((info) => {
                    if (this.validateRegisterBank) {
                        this.saveBankInfo(info)
                        return
                    }
                    if (this.addedPlatform.length > 0) {
                        this.savePlatformsInfo(info)
                        return
                    }
                    this.$router.push('/modelo/' + info.id + '/profile')
                })
                .catch(() => {
                    console.log('no se guardo la informacion de las modelos')
                })
        },
        savePlatformsInfo(info) {
            API.saveModelPlatform(this.addedPlatform, info.token, info.id)
                .then((platforms) => {
                    this.$router.push('/modelo/' + info.id + '/profile')
                })
                .catch(() => {
                    console.log('no se guardo la informacion de las modelos')
                })
        },
        saveBankInfo(info) {
            var infoBank = {
                name: this.$v.nombreTitularValue.$model,
                document_type: this.$v.typeDocumentTitularValue.$model,
                document: this.$v.documentTitularValue.$model,
                bank: this.$v.bankValue.$model,
                acount_type: this.$v.bankTypeValue.$model,
                bank_account: this.$v.CuentaTitularValue.$model
            }
            API.saveBankInfo(infoBank, info.token, info.id)
                .then((bank) => {
                    if (this.addedPlatform.length > 0) {
                        this.savePlatformsInfo(info)
                    } else {
                        this.$router.push('/modelo/' + info.id + '/profile')
                    }
                })
                .catch(() => {
                    console.log('no se guardo la informacion de las modelos')
                })
        },
        validateBankInfo() {
            if (this.$v.nombreTitularValue.$model === null) {
                this.validateRegisterBank = false
                return true
            }
            if (this.$v.typeDocumentTitularValue.$model === null) {
                this.$v.typeDocumentTitularValue.$touch()
                this.$refs.bankdetails.show()
                return false
            }
            if (this.$v.documentTitularValue.$model === null) {
                this.$v.documentTitularValue.$touch()
                this.$refs.bankdetails.show()
                return false
            }
            if (this.$v.CuentaTitularValue.$model === null) {
                this.$v.CuentaTitularValue.$touch()
                this.$refs.bankdetails.show()
                return false
            }
            this.validateRegisterBank = true
            return true
        },
        closePlatformDetails() {
            this.$refs.platforms.hide()
        },
        deletePlatform(index) {
            this.cams[this.addedPlatform[index].camId].select = false
            this.$refs[('platform' + this.addedPlatform[index].camId)][0].style.backgroundColor = '#fff'
            this.addedPlatform.splice(index, 1)
        },
        selectPlatform(index) {
            var platform = 'platform' + index
            if (this.cams[index].select) {
                return
            }
            if (this.platformIndex !== null && !this.cams[this.platformIndex].select) {
                this.$refs[('platform' + this.platformIndex)][0].style.backgroundColor = '#fff'
            }
            this.$refs[platform][0].style.backgroundColor = '#e0b059'
            this.platformIndex = index
        },
        addUserPlatfom() {
            if (this.cams.length > 0) {
                var found = this.addedPlatform.find(element => element.camId === this.cams[this.platformIndex].id)
                if (found !== undefined) {
                    return
                }
            }
            if (this.modelUserPlatformValue === null) {
                this.$v.modelUserPlatformValue.$error = true
                return
            }
            var info = {
                img: this.cams[this.platformIndex].img,
                user_name: this.modelUserPlatformValue,
                camId: this.cams[this.platformIndex].id,
                platform_name: this.cams[this.platformIndex].name,
                password: this.modelUserPlatformPasswordValue
            }
            this.modelUserPlatformValue = null
            this.modelUserPlatformPasswordValue = null
            this.cams[this.platformIndex].select = true
            this.$refs[('platform' + this.platformIndex)][0].style.backgroundColor = 'chartreuse'
            this.addedPlatform.push(info)
        },
        closeBackDetails() {
            this.$refs.bankdetails.hide()
        },
        addbackDetails() {
            this.$refs.bankdetails.show()
        },
        addPlataform() {
            this.$refs.platforms.show()
        },
        getCountriesList: function() {
            this.$http.get('https://restcountries.com/v3.1/all').then(function(response) {
                var contries = []
                response.body.forEach(country => {
                    if (country.name.common === 'Tanzania') {
                        return
                    }
                    contries.push(country.name.common)
                })
                this.countries = contries.sort()
            })
        },
        getSedesList() {
            API.getSedesList()
                .then((res) => {
                    this.sedes = res
                })
        }
    },
    mounted() {
        this.getCountriesList()
        this.getSedesList()
    },
    data() {
        return {
            countries: [],
            nameValue: null,
            lastNameValue: null,
            typeDocumentValue: 'cc',
            documentValue: null,
            dayOfBirdthValue: null,
            countryValue: 'Colombia',
            turnoValue: 'm',
            phoneValue: null,
            emailValue: null,
            sedeValue: null,
            nombreTitularValue: null,
            typeDocumentTitularValue: 'cc',
            documentTitularValue: null,
            bankValue: null,
            bankTypeValue: 'a',
            CuentaTitularValue: null,
            modelUserPlatformValue: null,
            modelUserPlatformPasswordValue: null,
            validateRegisterBank: null,
            addedPlatform: [],
            platformIndex: null,
            sedes: [],
            cams: [
                {
                    id: 0,
                    name: 'Bongacams',
                    img: require('@/assets/plataformas/BongaCams.png'),
                    select: false
                },
                {
                    id: 1,
                    name: 'Cam4',
                    img: require('@/assets/plataformas/CAM4.png'),
                    select: false
                },
                {
                    id: 2,
                    name: 'Camsoda',
                    img: require('@/assets/plataformas/camsoda.png'),
                    select: false
                },
                {
                    id: 3,
                    name: 'Chaturbate',
                    img: require('@/assets/plataformas/chaturbate.svg'),
                    select: false
                },
                {
                    id: 4,
                    name: 'Skyprivate',
                    img: require('@/assets/plataformas/skyprivate.webp'),
                    select: false
                },
                {
                    id: 5,
                    name: 'Stripchat',
                    img: require('@/assets/plataformas/Stripchat.png'),
                    select: false
                },
                {
                    id: 6,
                    name: 'Myfreecams',
                    img: require('@/assets/plataformas/Myfreecams.png'),
                    select: false
                }
            ]
        }
    },
    validations: {
        bankTypeValue: {
            required
        },
        bankValue: {
            required
        },
        modelUserPlatformPasswordValue: {
            required
        },
        modelUserPlatformValue: {
            required
        },
        nombreTitularValue: {
            required
        },
        typeDocumentTitularValue: {
            required
        },
        documentTitularValue: {
            required
        },
        CuentaTitularValue: {
            required
        },
        nameValue: {
            required
        },
        lastNameValue: {
            required
        },
        typeDocumentValue: {
            required
        },
        documentValue: {
            required,
            numeric
        },
        dayOfBirdthValue: {
            required
        },
        countryValue: {
            required
        },
        turnoValue: {
            required
        },
        phoneValue: {
            required
        },
        emailValue: {
            required,
            email
        },
        sedeValue: {
            required
        }
    }
}
</script>

<style scoped>
    .add-model {
        background-color: #cdcdcd;
        min-height: 100vh;
        padding: 50px;
        color: #000;
    }
    .info {
        padding: 50px;
        width: 100%;
        display: flex;
    }
    .info > .column {
        padding: 30px;
        width: 50%;
        border-style: solid;
        border-color: #fff;
    }
    .column > center {
        padding: 15px;
        display: grid;
    }
    .column > center > label, .info-wrapper > label, .info-wrapper > div > label {
        font-weight: bold;
        margin: 12px;
    }
    .column > center > input, select, .info-wrapper > input, .info-wrapper > div > input {
        min-width: 350px;
        height: 35px;
        text-align: center;
        border-style: ridge;
        border-radius: 15px;
    }
    .column > center > div > button, .column > center > button, .info-wrapper > button, .info-wrapper > div > .platform-button {
        margin: auto;
        margin-top: 35px;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    .info-wrapper > div > .platform-button {
        margin-top: 20px;
        width: 200px;
        height: 40px;
        margin-left: 10px;
    }
    /deep/ .column > center > .vue-tel-input {
        background-color: #fff;
        border-radius: 15px;
        border-style: ridge;
    }
    /deep/ .column > center > .vue-tel-input > input {
        height: 40px;
        text-align: center;
        border-radius: 15px;
        margin-left: -57px;
    }
    .column > center > .register-button {
        height: 40px;
        width: 250px;
    }
    /deep/ .check-number-modal-header {
        text-align: center;
        padding: 0;
        padding-top: 10px;
        display: block;
    }
    /deep/ .check-number-modal-header > button {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .info-wrapper > div {
        display: flex;
    }
    .info-wrapper > div > .img-container {
        border-radius: 50%;
        -webkit-box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
        -moz-box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
        box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
    }
    .fa-trash {
        padding: 20px;
    }
    .fa-trash:hover {
        color:red
    }
    .info-wrapper > div > img {
        padding: 25px;
        height: 70px;
    }
    .info-wrapper > div > label {
        padding: 10px;
    }
    .info-wrapper > div > div {
        width: 100px;
        height: auto;
        margin: 5px;
    }
    .info-wrapper > div > div > img {
        width: 100px;
        padding: 10px;
    }
    .error {
        color: red;
        font-size: 12px;
    }
    .info-wrapper > .form {
        display: grid;
    }
</style>



// WEBPACK FOOTER //
// src/components/Modelos/AgregarModelo.vue